import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Section174AdjAllocationsService {

  constructor(private http: HttpClient) { }

  /**
   * Get JSON object from backend - uses HTTP GET with query params
   * Matching AngularJS JsonObjectFactory.getJSONObj pattern
   * @param baseUrl Base URL for API
   * @param specificParams Specific parameters for this request (action_code, etc.)
   * @param globalParams Global params from globalService.globalParams
   * @param filterParams Filter parameters from workspace
   */
  getJsonObject(
    baseUrl: string, 
    specificParams: any, 
    globalParams: any = {}, 
    filterParams: any = {}
  ): Observable<any> {
    const url = baseUrl + '/loadJsonObject';

    // Merge order: globalParams -> filterParams -> specificParams (specific overrides)
    const mergedParams: { [key: string]: any } = {};
    
    // Add globalParams
    for (const key in globalParams) {
      if (globalParams.hasOwnProperty(key)) {
        mergedParams[key] = globalParams[key];
      }
    }
    
    // Add filterParams (overrides globalParams)
    for (const key in filterParams) {
      if (filterParams.hasOwnProperty(key)) {
        mergedParams[key] = filterParams[key];
      }
    }
    
    // Add specificParams (overrides everything)
    for (const key in specificParams) {
      if (specificParams.hasOwnProperty(key)) {
        mergedParams[key] = specificParams[key];
      }
    }

    // Build HttpParams from merged object
    let httpParams = new HttpParams();
    for (const key in mergedParams) {
      if (mergedParams.hasOwnProperty(key)) {
        const value = mergedParams[key];
        if (value !== undefined && value !== null) {
          httpParams = httpParams.set(key, String(value));
        }
      }
    }

    // Use HTTP GET with query params (matching AngularJS pattern)
    return this.http.get<any>(url, { 
      params: httpParams, 
      withCredentials: true 
    }).pipe(
      catchError(error => {
        console.error('HTTP GET Error:', error);
        return throwError(() => error);
      })
    );
  }

  /**
   * Save Section 174 data (uses POST with url-encoded body)
   * @param baseUrl Base URL for API
   * @param data Data to save
   * @param globalParams Global params from globalService.globalParams
   * @param filterParams Filter parameters
   */
  saveSection174(
    baseUrl: string,
    data: any[],
    globalParams: any = {},
    filterParams: any = {}
  ): Observable<any> {
    const url = baseUrl + '/saveJsonObject?action_code=xk42kn';

    const jsonObj = JSON.stringify(data);
    const jsonSettings = JSON.stringify(data);

    // Merge globalParams and filterParams
    let params = _.merge({}, globalParams, filterParams);
    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettings;
    params.process_name = 'SAVE_SECTION174_DETAILS';

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, typeof params[key] === 'object' ? JSON.stringify(params[key]) : params[key].toString());
      }
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true }).pipe(
      catchError(error => {
        console.error('HTTP POST Error:', error);
        return throwError(() => error);
      })
    );
  }
}
